export enum LIMIT_TYPES {
    Automatic = "automatic",
    Custom = "custom"
}

export enum LOADERS {
    Data = "data",
    Submit = "submit"
}
